import type { RouteDef, RuntimeFlags } from '@cobliteam/dashboard/src/dashboardDef.type';

// hasCameraFlag and hasRedeCan are flags that are used to determine if a route is visible or not
const RUNTIME_FLAG_KEYS: (keyof RuntimeFlags)[] = [
  'hasCameraFlag',
  'hasRedeCan',
  'hasNoValidGroups',
  'hasGroupsRestriction',
  'isSafetyCoacher',
  'hasIdentifiers',
  'isOnboardingFleet',
];
const RUNTIME_FLAG_KEYS_WITH_INVERSE_LOGIC: (keyof RuntimeFlags)[] = ['hasGroupsRestriction']; // These flags show routes when runtime flag is false

const isVisible = (routeOrGroup: any, runtimeFlags: RuntimeFlags) => {
  return RUNTIME_FLAG_KEYS.every((flagKey) => {
    if (routeOrGroup[flagKey] !== undefined) {
      // For flags with inverse logic: route shows when runtime flag is false
      if (RUNTIME_FLAG_KEYS_WITH_INVERSE_LOGIC.includes(flagKey)) {
        return runtimeFlags[flagKey] === false;
      }

      // For all other flags: exact match between route flag and runtime flag
      return runtimeFlags[flagKey] === routeOrGroup[flagKey];
    }
    return true;
  });
};

const getRoutesWithPermissionAndFeatureFlagAndRuntimeFlag = (routesDef: RouteDef[], runtimeFlags: RuntimeFlags) => {
  if (runtimeFlags.hasNoValidGroups) return [];

  const routesDefWithRuntimeFlag = routesDef.reduce<RouteDef[]>((acc, route) => {
    const routesWithRuntimeFlag = route.routes?.filter((subRoute) => {
      subRoute.routes = subRoute.routes?.filter((group) => isVisible(group, runtimeFlags));
      return isVisible(subRoute, runtimeFlags);
    });

    if (routesWithRuntimeFlag?.length) {
      acc.push({ ...route, routes: routesWithRuntimeFlag });
      return acc;
    }

    if (isVisible(route, runtimeFlags)) acc.push(route);

    return acc;
  }, []);

  return routesDefWithRuntimeFlag;
};

export default getRoutesWithPermissionAndFeatureFlagAndRuntimeFlag;
